import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { search, save, remove } from '../../modules/logistics/assignedLoadingNumber';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	/** @namespace state.lists.assignedLoadingNumberIds **/
	/** @namespace state.maps.assignedLoadingNumber **/
	let assignedLoadingNumbers = [];
	if (state.lists.assignedLoadingNumberIds) {
		assignedLoadingNumbers = _.compact(
			_.map(state.lists.assignedLoadingNumberIds, (id) => state.maps.assignedLoadingNumber[id])
		);
	}
	const canMakeUpdates = !!_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false);
	return {
		assignedLoadingNumbers,
		stationMap: state.maps.station || {},
		terminalMap: state.maps.terminal || {},
		userMap: state.maps.user || {},
		resourceMap: state.maps.resource || {},
		canMakeUpdates,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchAssignedLoadingNumbers: search,
			saveAssignedLoadingNumbers: save,
			removeAssignedLoadingNumbers: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
